export const HOT_YOTER_DEFAULT_SLUG = 'הטבות_הוטיותר';
export const HOT_YOTER_ALL_GROUPS_ID = -1;
export const HOT_YOTER_ALL_CATEGORIES_ID = -1;
export const HOT_YOTER_VIEW_PURCHASED_LABEL = 'לצפייה';
export const HOT_YOTER_PURCHASED_BENEFITS_LABEL = 'הטבות שמומשו:';
